import React from 'react';

const Imc = ({ exams }) => {
    const toNumber = (v) => {
        if (v === null || v === undefined) return NaN;
        return typeof v === 'number' ? v : Number(v);
    };

    const getMessage = (rawImc) => {
        const imc = toNumber(rawImc);
        if (Number.isNaN(imc)) return '';
        return imc >= 30 ? 'En riesgo' : 'Saludable';
    };

    const fmt = (value, suffix = '') => {
        if (value === null || value === undefined || value === '') return '';
        return `${value}${suffix}`;
    };

    return (
        <>
            {exams.map((item, pos) => {
                const imcMessage = getMessage(item?.currentLastResult?.imc ?? null);

                return (
                    <React.Fragment key={pos}>
                        <tr>
                            <td>Peso</td>
                            <td>
                                {item?.hasPreviousYear
                                    ? fmt(item?.previousLastResult?.weight ?? '', ' Kg')
                                    : ''}
                            </td>
                            <td>
                                {item?.hasCurrentYear
                                    ? fmt(item?.currentLastResult?.weight ?? '', ' Kg')
                                    : ''}
                            </td>
                            <td></td>
                            <td>{imcMessage}</td>
                        </tr>

                        <tr>
                            <td>IMC</td>
                            <td>{item?.hasPreviousYear ? item?.previousLastResult?.imc ?? '' : ''}</td>
                            <td>{item?.hasCurrentYear ? item?.currentLastResult?.imc ?? '' : ''}</td>
                            <td></td>
                            <td>{imcMessage}</td>
                        </tr>

                        <tr>
                            <td>Circunferencia abdominal</td>
                            <td>
                                {item?.hasPreviousYear
                                    ? fmt(item?.previousLastResult?.circumference ?? '', ' Cm')
                                    : ''}
                            </td>
                            <td>
                                {item?.hasCurrentYear
                                    ? fmt(item?.currentLastResult?.circumference ?? '', ' Cm')
                                    : ''}
                            </td>
                            <td></td>
                            <td>{imcMessage}</td>
                        </tr>
                    </React.Fragment>
                );
            })}
        </>
    );
};

export default Imc;
